import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
  viewChild,
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute, Router } from "@angular/router";
import { finalize, first } from "rxjs/operators";
import { TranslationDialogService } from "src/app/shared/translation-dialog/translation-dialog.service";
import {
  CONFIRM_DIALOG_MESSAGE,
  CONFIRM_DIALOG_MESSAGE_DELETE,
} from "../../locale/consts.en";
import { ItemEditComponent } from "../item-edit/item-edit.component";
import { MasterDataService } from "../master-data/master-data-service";
import {
  FormType,
  MasterData,
  OrderType,
} from "../master-data/master-data.model";
import {
  ConfDialogType,
  ConfirmDialogModel,
} from "../shared/confirm-dialog/confim-dialog.model";
import { ConfirmDialogComponent } from "../shared/confirm-dialog/confirm-dialog.component";
import { sortByStringWithEmptyAtEnd } from "../shared/helpers/helper-functions";

@Component({
  selector: "app-types",
  templateUrl: "./types.component.html",
  styleUrls: ["./types.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TypesComponent implements OnInit, AfterViewInit {
  private dialog = inject(MatDialog);
  private masterDataService = inject(MasterDataService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  readonly translationDialogService = inject(TranslationDialogService);

  readonly sort = viewChild(MatSort);
  dataSource: MatTableDataSource<OrderType>;
  displayedColumns: string[] = [
    "name",
    "externalId",
    "edit",
    "delete",
    "translations",
  ];
  types: OrderType[] = [];

  ngOnInit(): void {
    const types = this.route.snapshot.data.types ?? [];
    this.types = sortByStringWithEmptyAtEnd(types, (item) => item.name);
    // this.route.snapshot.data.types.sort((a, b) =>
    //   a.name.localeCompare(b.name)
    // );
    this.dataSource = new MatTableDataSource(this.types);
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  saveTypeToApi(type: OrderType) {
    this.masterDataService
      .updateType(type)
      .pipe(
        finalize(() => {
          this.masterDataService
            .getTypes()
            .pipe(first())
            .subscribe((types) => {
              this.types = types;
              this.dataSource.data = this.types;
            });
        }),
      )
      .subscribe({
        next: (response) => {
          this.masterDataService.handleResponse(response);
        },
        error: () => this.masterDataService.savingErrorMessage(),
      });
  }

  updateType(t: OrderType) {
    const type = new OrderType();
    Object.assign(type, t);
    const dialogRef = this.dialog.open(ItemEditComponent, {
      width: "20vw",
      data: type,
    });
    dialogRef.afterClosed().subscribe(async (data: OrderType) => {
      if (data != null) {
        this.saveTypeToApi(data);
      }
    });
  }

  deleteType(type: FormType) {
    const dialogData = new ConfirmDialogModel(
      CONFIRM_DIALOG_MESSAGE,
      CONFIRM_DIALOG_MESSAGE_DELETE,
      ConfDialogType.MESSAGE,
    );
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData,
    });
  }

  onAddType() {
    const type = new OrderType();
    const dialogRef = this.dialog.open(ItemEditComponent, {
      width: "20vw",
      data: type,
    });
    dialogRef.afterClosed().subscribe(async (data: OrderType) => {
      if (data != null) {
        this.saveTypeToApi(data);
      }
    });
  }

  onBack() {
    this.router.navigate(["/"]).then();
  }

  openTranslationsDialog(item: MasterData): void {
    this.translationDialogService.open(item, "Type").subscribe((result) => {
      if (result) {
        item.translations = result;
        this.saveTypeToApi(item as OrderType);
      }
    });
  }
}
